//---------------------------------------------------------
// Soft: read-only SOFT_LINODE_MUTATE flag (GET /oam/soft/linode-mutate).
// While it is off, Power, Reboot, Provision and Delete-with-Linode show as
// disabled with LINODE_PAUSED_TOOLTIP. If the flag can't be read, nothing is
// disabled here and a LINODE_MUTATE_DISABLED reply shows the same sentence.
//---------------------------------------------------------
import {GET_OAM} from 'connector/fetcher/fetcher_oam';
import {useEffect, useState} from 'react';

export const LINODE_PAUSED_TOOLTIP = 'Paused for a security fix. Linode changes are turned off for now.';

const TTL_MS = 60_000;
let cached: {paused: boolean; at: number} | null = null;
let inflight: Promise<boolean> | null = null;

export async function fetchLinodePaused(): Promise<boolean> {
	if (cached && Date.now() - cached.at < TTL_MS) return cached.paused;
	if (!inflight) {
		inflight = GET_OAM<{enabled?: boolean}>(`/soft/linode-mutate`)
			.then(resp => {
				const paused = resp.code === 200 && resp.data?.enabled === false;
				if (resp.code === 200) cached = {paused, at: Date.now()};
				return paused;
			})
			.catch(() => false)
			.finally(() => {
				inflight = null;
			});
	}
	return inflight;
}

/** For tests. */
export function resetLinodePausedCache() {
	cached = null;
	inflight = null;
}

export function useLinodePaused(): boolean {
	const [paused, setPaused] = useState<boolean>(cached?.paused ?? false);
	useEffect(() => {
		let live = true;
		fetchLinodePaused().then(p => {
			if (live) setPaused(p);
		});
		return () => {
			live = false;
		};
	}, []);
	return paused;
}
